import React, { useState } from 'react';
import Analytics from '../../utils/analytics';
import './BookingDetailsModal.css';

export default function BookingDetailsModal({ booking, onClose, onComplete }) {
    const [paymentCollected, setPaymentCollected] = useState(false);
    const [confirming, setConfirming] = useState(false);

    const handleNavigate = () => {
        const address = booking.address || booking.location?.address;
        if (address) {
            const encoded = encodeURIComponent(address);
            window.open(`https://maps.google.com/?q=${encoded}`, '_blank');
        }
    };

    const handleCompleteClick = () => {
        setConfirming(true);
    };

    const handleConfirmComplete = () => {
        if (paymentCollected) {
            onComplete(booking);

            // Analytics: Track artisan job completion
            Analytics.pushCustomEvent('job_completed', {
                value: (booking.payout_cents / 100 || 104).toFixed(2),
                payment_method: 'OFFLINE'
            });
        }
    };

    if (!booking) return null;

    return (
        <div className="details-modal-overlay">
            <div className="details-modal-container animate-slideUp">
                <div className="details-header">
                    <button className="btn-close" onClick={onClose}>&times;</button>
                    <h2>Booking Details</h2>
                </div>

                <div className="details-content">
                    <div className="section-block">
                        <label>Time & Date</label>
                        <p className="highlight-text">
                            {booking.date} • {booking.start_time || booking.startTime?.substring(11, 16)}
                        </p>
                    </div>

                    <div className="section-block">
                        <label>Customer</label>
                        <h3>{booking.customer_name || booking.customerName || 'Customer'}</h3>
                        <p className="service-name">{booking.package_name || booking.serviceName}</p>
                    </div>

                    <div className="section-block">
                        <label>Location</label>
                        <p>{booking.address || booking.location?.address || 'No Location'}</p>
                        <button className="btn-navigate-large" onClick={handleNavigate}>
                            📍 Navigate to Location
                        </button>
                    </div>

                    <div className="section-block">
                        <label>Payment to Collect</label>
                        <p className="price-large">${(booking.payout_cents / 100 || 104).toFixed(2)}</p>
                    </div>

                    {booking.notes && (
                        <div className="section-block">
                            <label>Notes</label>
                            <p className="notes-text">{booking.notes}</p>
                        </div>
                    )}

                    {confirming && (
                        <div className="confirmation-box">
                            <p>Have you collected payment?</p>
                            <div className="checkbox-row">
                                <input
                                    type="checkbox"
                                    id="payment-check-modal"
                                    checked={paymentCollected}
                                    onChange={(e) => setPaymentCollected(e.target.checked)}
                                />
                                <label htmlFor="payment-check-modal">
                                    I collected <strong>${(booking.payout_cents / 100 || 104).toFixed(2)}</strong>
                                </label>
                            </div>
                        </div>
                    )}

                    {/* Add padding at bottom so content isn't hidden by sticky bar */}
                    <div style={{ height: '80px' }}></div>
                </div>

                <div className="sticky-action-bar">
                    {confirming ? (
                        <div className="action-row">
                            <button className="btn-secondary" onClick={() => setConfirming(false)}>Back</button>
                            <button
                                className="btn-primary flex-1"
                                disabled={!paymentCollected}
                                onClick={handleConfirmComplete}
                            >
                                Confirm & Complete
                            </button>
                        </div>
                    ) : (
                        <button className="btn-success-full" onClick={handleCompleteClick}>
                            Mark as Completed
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
